export const formBuilder = () => {
  return {
    publish: 'Publicar',
    type: 'Tipo',
    service: 'Servicio',
    trade: 'Comercio',
    publish_form: '¡Publicar Formulario!',
    publish_form_message_0:
      'Estás a punto de publicar un formulario de campo que se mostrará a todos los usuarios de campo cuando se cree una orden de trabajo con ',
    publish_form_message_1: 'y',
    publish_form_message_2: 'se crea.',
    delete_element: 'Eliminar Elemento',
    delete_element_message:
      'Estás a punto de eliminar este elemento de la página. ¿Quieres continuar?',
    yes: 'Sí',
    ok: 'Ok',
    deactivate_field_form_title: 'Desactivar Formulario de Campo',
    deactivate_form_main_message_0:
      'Desactivar este formulario publicado impedirá que los usuarios accedan a él, y el sistema volverá al formulario predeterminado para esta combinación de oficio, tipo y servicio.',
    deactivate_form_main_message_1:
      'Nota: Editar y volver a publicar este formulario permitirá a los usuarios acceder a él para todas las órdenes de trabajo en curso y abiertas.',
    deactivate_form_extra_message:
      '¿Quieres desactivar este formulario de campo?',
    section_title: 'Título de la Sección',
    element: 'Elemento',
    element_plural: 'Elementos',
    no_elements: 'No hay elementos',
    page_one: 'Página 1',
    section_one: 'Sección 1',
    duplicate_wo: 'Asignación Duplicada de OT',
    duplicate_wo_title: '¡Se Encontraron Errores!',
    duplicate_wo_message_0:
      'Ya hay un formulario de campo publicado con los atributos de orden de trabajo de Comercio - ',
    duplicate_wo_message_1: ' Tipo - ',
    duplicate_wo_message_2: ', y Servicio - ',
    duplicate_wo_message_3:
      '.  Desactiva el formulario existente o reasigna este formulario para continuar.',
    duplicate_form_name_message_0:
      'Ya hay un formulario de campo publicado con el nombre del formulario ',
    duplicate_form_name_message_1:
      '. Desactiva el formulario existente o actualiza el nombre del formulario para continuar.',
    unsaved_changes: 'Cambios No Guardados',
    unsaved_changes_message:
      'Tienes cambios no guardados. ¿Quieres guardar esos cambios?',
    save: 'Guardar',
    discard: 'Descartar',
    preview: 'Vista Previa',
    draft: 'Borrador',
    clone: 'Clonar',
    delete: 'Eliminar',
    cancel: 'Cancelar',
    center_panel: {
      deactivate: 'Desactivar',
      publish: 'Publicar',
      lets_build: '¡Vamos a construir un formulario increíble!',
      empty_message:
        'Construye la estructura de tu formulario usando páginas y secciones, luego agrega todos los elementos de formulario que desees haciendo clic en "+" o arrastrándolos al espacio a continuación. Encontrarás muchas opciones disponibles en el panel izquierdo, en la pestaña Elementos.',
      published_mode: 'Modo Publicado',
      draft_mode: 'Modo Borrador',
      empty_search_message:
        '¡Ups.. No hay elementos que coincidan con tu búsqueda. Verifica tus criterios de búsqueda e inténtalo de nuevo.'
    },
    audit_trail_status: {
      active: 'Publicado',
      deleted: 'Eliminado',
      draft: 'Borrador',
      cloned: 'Clonado',
      saved: 'Guardado',
      deactivated: 'Desactivado'
    },
    left_panel: {
      structure_tab_message_0:
        'Crea secciones adicionales seleccionando "+" para dividir tus elementos.',
      structure_tab_message_1:
        'La creación de páginas adicionales está por llegar.',
      audit: 'Registro de Auditoría',
      structure: 'Estructura',
      elements: 'Elementos',
      details: 'Detalles',
      description: 'Descripción',
      pages: 'Páginas',
      select_drop_message:
        'Selecciona y "+" o arrastra y suelta elementos en tu página para construir tu increíble formulario.',
      audit_trail: 'Registro de Auditoría',
      sections: 'Secciones',

      remove_section_title: 'Eliminar Sección',
      remove_section_message:
        '¿Estás seguro de que quieres eliminar la sección {{sectionTitle}}?',
      accept: 'Aceptar',
      cancel: 'Cancelar'
    },
    right_panel: {
      required: 'Requerido',
      mandatory: 'Obligatorio',
      optional: 'Opcional',
      add_element: 'Agregar un elemento a tu formulario',
      fields_reorder: 'Los campos se pueden reorganizar arrastrándolos',
      continue_message_title:
        'Selecciona un elemento para personalizar su contenido.',
      continue_message_text:
        'Continúa agregando elementos y personalizando el contenido para construir tu formulario de campo deseado.'
    },
    dragged_element: {
      helpful_hint: 'Pista Útil',
      time_stamp: 'Marca de Tiempo',
      required_field: 'Campo Obligatorio',
      logic: 'Lógica'
    },
    elements: {
      product_name: 'Nombre del producto',
      product_type: 'Tipo de producto',
      product_description: 'Descripción del producto',
      price_each: 'Precio por unidad',
      total_each: 'Total por unidad',
      hidden: 'Oculto',
      view_only: 'Solo visualización',
      editable: 'Editable',
      product_creation: 'Creación de productos',
      authorization_field_message_one:
        'El campo de autorización generará una hermosa vista previa en la aplicación de todos los elementos completados dentro del formulario para que su cliente los revise, firme y autorice.',
      authorization_field_message_two:
        'Este será el último elemento listado en el formulario.',
      due_on_receipt: 'A la recepción',
      net_7: 'Net 7',
      net_15: 'Net 15',
      net_30: 'Net 30',
      net_45: 'Net 45',
      authorization_to_proceed: 'Autorización para proceder',
      payment_terms: 'Términos de pago',
      due_date: 'Fecha de vencimiento',
      signature_required: 'Firma requerida',
      signature_and_name_required: 'Firma y nombre requeridos',
      authorization_field: 'Campo de autorización',
      labor_type: 'Tipo de Trabajo',
      if_one_material_is_populated: 'Si un material es rellenado',
      if_more_than_one_material_is_populated:
        'Si más de un material es rellenado',
      enable_selections_based_on_salesforce:
        'Habilitar - Selección basada en Salesforce',
      enable_custom_options: 'Habilitar - Opciones Personalizadas',
      enable: 'Habilitar',
      disable: 'Deshabilitar',
      description: 'Descripción',
      line_items: 'Campo de elementos de línea',
      items: 'Elementos',
      item_price: 'Precio de Elemento',
      tax: 'Impuesto',
      total_amount_due: 'Monto Total Adeudado',
      line_items_message_one:
        'Los Ítems de Línea permiten al Técnico agregar los costos incurridos a una OT. Cada Ítem de Línea tiene un producto/servicio, monto, cantidad, tasa de impuesto y monto total.',
      line_items_message_two:
        'Esta información puede utilizarse para ayudar a generar Facturas.',
      enable_item_price_tax_total_price:
        'Habilitar campo de precio, impuestos y precio total',
      disable_item_price_tax_total_price:
        'Deshabilitar campo de precio, impuestos y precio total',
      if_one_line_item_is_populated: 'Si un elemento en una línea es rellenado',
      if_more_than_one_line_item_is_populated:
        'Si más de un elemento en una línea es rellenado',
      line_items_descriptions_quantities_pricing:
        'Elementos de Línea - Descripción, Cantidad y Precio',
      products_services: 'Products/Services',
      service_checklist: 'Lista de Verificación de Servicios',
      material_parts: 'Lista de Material / Partes',
      equipment_inventory: 'Inventario de Equipos',
      enter_value: 'Ingresar Valor',
      text_description: 'Descripción de Texto',
      dropdown_selection: 'Selección de Menú Desplegable',
      selection_type: 'Tipo de Selección',
      single_selection: 'Selección Única',
      multiple_selections: 'Selecciones Múltiples',
      helpful_hint_title:
        'Consejo Útil (el ícono se muestra cuando se ingresa texto)',
      helpful_hint_placeholder: 'Ingrese una descripción útil',
      title_title: 'Título / Descripción del Elemento',
      time_stamp_title: 'Marca de Tiempo',
      title_placeholder:
        'Ingrese título / descripción del elemento (longitud máxima de 00 caracteres)',
      buttons_generator: '# de botones',
      button_label_a: 'Botón',
      button_label_b: 'título',
      created_button_placeholder: 'Ingrese título (menos de 25 caracteres)',
      required_field_title: 'Campo Obligatorio',
      selection_title: 'Selección / opción',
      empty_state_message_title: 'Mensaje de Estado Vacío',
      text_input_placeholder: 'Ingrese título / descripción del elemento',
      empty_state_message_placeholder: 'Ingrese mensaje de estado vacío',
      input_field_type_title: 'Tipo de Campo de Entrada',
      alpha_numeric: 'Alfa / Numérico',
      alpha_only: 'Solo Alfabético',
      numeric_only: 'Solo Numérico',
      dollar_value: 'Valor en Dólares ($)',
      percentage_value: 'Valor en Porcentaje (%)',
      date_time: 'Fecha',
      nested_logic: 'Lógica Anidada',
      logical_action: 'Acción Lógica',
      if_text_is_populated: 'Si el texto está completado',
      then_perform: 'Entonces Realizar',
      selection_button: 'Agregar Selección',
      selection: 'Selección',
      selection_input_placeholder:
        'Ingrese la selección / descripción del elemento (longitud máxima de 00 caracteres)',
      allow_multiple_selections: 'Permitir selecciones múltiples',
      number_of_selections: '# de selecciones',
      yes: 'Sí',
      no: 'No',
      mandatory: 'Obligatorio',
      optional: 'Opcional',
      check_box: 'Casilla de Verificación',
      none: 'Ninguno',
      dropdown_selection_option: 'Si se selecciona la {{option}}',
      then_perform_placeholder:
        'Agregar elemento a la sección de lógica anidada',
      enter_title_placeholder: 'Ingrese Título / Descripción',
      checklist_item: 'Ítem de Lista de Verificación',
      selection_option: 'Selección / opción',
      on_off: 'Encendido / Apagado',
      yes_no: 'Sí / No',
      toggle: 'Interruptor',
      if_check_mark_is_selected:
        'Si se selecciona la "marca de verificación" entonces',
      if_red_x_is_selected: 'Si se selecciona la "X" roja entonces',
      photos: 'Fotos',
      number_of_photos: '# de Fotos',
      photo_title: 'Título / descripción',
      location: 'Ubicación (GPS)',
      attributes: 'Atributos',
      photo_number: 'Foto {{number}}',
      take_photo_or_upload_from_gallery: 'Tomar Foto &/o Subir desde Galería',
      take_photo_only: 'Tomar Foto (Solo)',
      upload_photo_from_gallery_only: 'Subir Foto Desde Galería (Solo)',
      multi_button_selection: 'Selección Multi-Botón',
      number_of_buttons: '# de botones',
      button_number_title: 'Título del Botón {{number}}',
      button_placeholder: 'Ingrese título (menos de 25 caracteres)',
      button_selection_option: 'Si se selecciona el botón {{option}}',
      signature: 'Firma',
      entered_name_required: 'Nombre ingresado requerido',
      entered_name_optional: 'Nombre ingresado opcional',
      coming_soon: 'Próximamente',
      alpha_numeric_special_characters:
        'Alfa / Numérico / Caracteres Especiales',
      attachments: 'Adjuntos',
      number_of_attachments: '# de Adjuntos',
      all_document_formats: 'Todos los formatos de documento',
      pdf_only: 'Solo PDF',
      jpeg_and_png_only: 'Solo JPEG y PNG',
      csv_spreadsheet_only: 'Solo CSV | Hoja de Cálculo',
      docx_only: 'Solo DOCX | Documentos de Word',
      attachment_title: 'Título / descripción',
      attachment_number: 'Adjunto {{number}}'
    },
    top_bar: {
      draft: 'Borrador',
      published: 'Publicado',
      inactive: 'Inactivo'
    }
  }
}
